import { useStore } from '@/store';
import {
  SET_MAIN_TITLE,
  SET_TITLE_ICON,
} from '@/store/mutations/mutationTypes';
import { computed } from '@vue/composition-api';
import { commitToStore } from '../initialize';

export const useTitle = () => {
  const store = useStore();

  const setTitle = ({ title, icon }: { title: string; icon: string }) => {
    const commits = [
      { type: SET_TITLE_ICON, payload: icon },
      { type: SET_MAIN_TITLE, payload: title },
    ];
    commitToStore(store, commits);
  };

  return {
    title: computed(() => store.state.title.main),
    icon: computed(() => store.state.title.icon),
    setTitle,
  };
};
